import React from "react";
import clsx from "clsx";
import {
  APICategory,
  LinkedAccountChatFilter,
  LinkedAccountFileStorageFilter,
  LinkedAccountKnowledgeBaseFilter,
  UnreleasedAPICategory,
} from "../../../../../../../../models/Entities";
import { ROW_CLASS } from "../constants";
import { SyncSelection } from "../types";
import FileStorageSyncSelectionRow from "./FileStorageSyncSelectionRow";
import ChatSyncSelectionRow from "./ChatSyncSelectionRow";
import KnowledgeBaseSyncSelectionRow from "./KnowledgeBaseSyncSelectionRow";

interface Props {
  category: APICategory | UnreleasedAPICategory;
  selection: SyncSelection;
  showTopBorder: boolean;
  // react-window positions each row through this style; dropping it stacks every row at the top.
  style?: React.CSSProperties;
}

const SyncSelectionRow = ({ category, selection, showTopBorder, style }: Props) => (
  <div
    role="row"
    style={style}
    className={clsx(ROW_CLASS, "h-14", showTopBorder && "border-t border-gray-10")}
    data-testid="sync-selection-row"
  >
    {category === APICategory.filestorage ? (
      <FileStorageSyncSelectionRow selection={selection as LinkedAccountFileStorageFilter} />
    ) : category === APICategory.chat ? (
      <ChatSyncSelectionRow selection={selection as LinkedAccountChatFilter} />
    ) : (
      <KnowledgeBaseSyncSelectionRow selection={selection as LinkedAccountKnowledgeBaseFilter} />
    )}
  </div>
);

export default SyncSelectionRow;
